import BaseClient from '@/app/model/api/response/baseApiClient'

class GroupListApi extends BaseClient {
  public getGroupList (data: any) {
    const path = '/v1/master/groups'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data !== '') {
      if (data.text !== '') {
        params.append('word', data.text)
      }

      if (data.num !== 0) {
        params.append('order_name', data.order_name)
        params.append('sort', data.sort)
      }
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new GroupListApi()
